type Stage = 'local' | 'test' | 'dev' | 'staging' | 'prod';
import { stage } from '@/config';

const getCurrentEnvironment = (): Stage => {
  return stage;
};

export enum FeatureFlagKeys {
  NEW_FIRE_KASE_UI = 'NEW_FIRE_KASE_UI',
  LIVE_STT_REALTIME = 'LIVE_STT_REALTIME',
}

type FeatureFlags = {
  [key: string]: {
    enabledIn: Stage[];
  };
};

export const FEATURE_FLAGS: FeatureFlags = {
  NEW_FIRE_KASE_UI: {
    enabledIn: ['local', 'test', 'dev', 'staging'],
  },
  LIVE_STT_REALTIME: {
    enabledIn: ['local', 'test', 'dev', 'staging', 'prod'],
  },
};

export const isFeatureEnabled = (
  featureName: keyof typeof FEATURE_FLAGS,
): boolean => {
  const currentEnv = getCurrentEnvironment();
  const feature = FEATURE_FLAGS[featureName];
  if (!feature) return false;

  return feature.enabledIn.includes(currentEnv);
};
